import { render, staticRenderFns } from "./secondaryMenu.vue?vue&type=template&id=273f3a48&scoped=true&"
var script = {}
import style0 from "./secondaryMenu.vue?vue&type=style&index=0&id=273f3a48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273f3a48",
  null
  
)

export default component.exports